import { Result } from "appworks/model/gameplay/records/results/result";

export class PretellResult extends Result {
    public animationType: number;
}